export enum TeamAnchorLinks {
  TeamProject = 'teamProject',
  Note = 'note',
  TeamComponents = 'teamComponents',
  Security = 'security',
  DefaultCoordinatesSystem = 'defaultCoordinatesSystem',
  DataCollectionAndScanning = 'dataCollectionAndScanning',
  Api = 'api',
  Packages = 'packages',
  Options = 'options',
  VSite = 'vSite',
  Tickets = 'tickets',
}
